(function () {
  "use strict";

  angular
    .module("admin.users.details.user_lock_logs.service", [])
    .factory("UserLockLogsService", UserLockLogsService);

  /** @ngInject */
  function UserLockLogsService($http, $q, API) {
    function list(userId) {
      var defer = $q.defer();

      $http
        .get(API.API_URL + "admin/users/" + userId + "/user_lock_logs")
        .success(defer.resolve)
        .error(defer.reject);

      return defer.promise;
    }

    return {
      list: list,
    };
  }
})();
